var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-1 white",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-fluid vjs-default-skin"})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }